const normalizeUrl = (value: string) => value.replace(/\/+$/, "");

// Fallback is the LOCAL dev URL — production values are injected via .env.production / DefinePlugin
const fallbackAdminApiUrl = "http://erpapi.kaanpos.com";

const readDefinedString = (value: string | undefined) => {
  if (typeof value !== "string") {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed || undefined;
};

const adminApiUrl =
  readDefinedString(
    typeof __ADMIN_API_URL__ !== "undefined" ? __ADMIN_API_URL__ : undefined,
  ) || fallbackAdminApiUrl;

const adminAppBasePath = readDefinedString(
  typeof __ADMIN_APP_BASE_PATH__ !== "undefined"
    ? __ADMIN_APP_BASE_PATH__
    : undefined,
);

const adminPublicPath = readDefinedString(
  typeof __ADMIN_PUBLIC_PATH__ !== "undefined"
    ? __ADMIN_PUBLIC_PATH__
    : undefined,
);

export const runtimeConfig = {
  adminApiUrl: normalizeUrl(adminApiUrl),
  adminAppBasePath,
  adminPublicPath,
} as const;
